<script setup lang="ts">
import BottomFix from '~/component/BottomFix.vue'
import TermsModal from '~/component/TermsModal.vue'
import { usePaymentStore } from '~/stores/payment'

const { $bottomFix, $termsModal } = useNuxtApp()

const paymentStore = usePaymentStore()
const currentPage = computed(() => paymentStore.page)

const handleTermsClick = () => {
  $termsModal.show('terms')
}

const handlePrivacyClick = () => {
  $termsModal.show('privacy')
}
const moveToBack = () => {
  const previousPath = localStorage.getItem('payBackPath')
  if (previousPath) {
    if (currentPage.value === 0) {
      useRouter().push(previousPath)
      localStorage.removeItem('payBackPath')
    } else {
      paymentStore.setPage(0)
    }
    return
  } else {
    if (currentPage.value === 0) {
      useRouter().push('/quick')
    } else {
      paymentStore.setPage(0)
    }
  }
}

onMounted(() => {
  $bottomFix.hide()
})
</script>
<template>
  <!-- #wrap -->
  <div id="signupWrap">
    <!-- #signupHeader -->
    <div id="signupHeader">
      <div class="inner">
        <a class="btnHeaderBack" @click="moveToBack">돌아가기</a>
      </div>
    </div>
    <!-- /#signupHeader -->
    <slot></slot>
    <hr />

    <!-- #footer -->
    <footer id="footer" class="outer">
      <ul class="agree">
        <li><a @click="handleTermsClick">이용약관</a></li>
        <li><a @click="handlePrivacyClick">개인정보처리방침</a></li>
      </ul>
      <p class="copyright">COPYRIGHT © EDUBRAIN, 2024. All rights reserved.</p>
    </footer>
    <!-- //#footer -->
    <BottomFix />
    <TermsModal />
  </div>
  <!-- /#wrap -->
</template>
<style>
@import '@/assets/css/style.css';
</style>
